import {
  Container,
  Button,
  Grid,
  Paper,
  TextField,
  IconButton,
  InputAdornment,
  CssBaseline,
  Typography
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import React, { useState, useEffect, useRef } from "react";
import useAuth from "../../hooks/useAuth";
//import logo from "../../assets/images/quanti-logo-white.png";
import logo from "../../assets/images/sims.png";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setState, login, forgotPassword } from "../../store/loginSlice";
//import { setState } from "../Admin/centralAdminSlice";

const Login = () => {
  const dispatch = useDispatch();
  const { setAuth } = useAuth();
  const userRef = useRef();
  const errRef = useRef();
  const [values, setValues] = useState({
    email: "",
    pass: "",
    showPass: false,
  });
  const [errMsg, setErrMsg] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    userRef.current.focus();
  }, []);

  useEffect(() => {
    setErrMsg("");
  }, [values.email, values.password]);

  const handlePassVisibilty = () => {
    setValues({
      ...values,
      showPass: !values.showPass,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      login({ method: "GET", email: values.email, password: values.password })
    )
      .then((res) => {
        // console.log("loginPayload", res?.payload);
        if (res.payload == "Invalid credential") {
          setErrMsg("Invalid Login Credentials");
        } else if(!res?.payload){
          setErrMsg("Failed to fetch");
        } else {
          setAuth(res?.payload);
          localStorage.setItem("data", JSON.stringify(res?.payload));
          localStorage.setItem("lastActiveTime", Date.now().toString());
          // dispatch(GetUserCountries({method: "Get", userid : res ?.payload.userID}));
          //Test
          dispatch(setState("isLoggedIn", true));
          navigate("/dashboard");
        }
      })
      .catch((err) => {
        if (!err?.response) {
          setErrMsg("No Server Response");
        } else if (err.response?.status === 400) {
          setErrMsg("Missing username or Password");
        } else if (err.response?.status === 401) {
          setErrMsg("UnAuthorized!");
        } else {
          setErrMsg("Login Failed");
        }
        errRef.current.focus();
      });
  };

  const handleForgotPasswordClick = (e) => {
    e.preventDefault();
    if (
      values.email == null ||
      values.email == undefined ||
      values.email == ""
    ) {
      setErrMsg('Please enter your email and press "Forgot Password"');
      return;
    }

    dispatch(forgotPassword({ method: "GET", email: values.email }))
      .then((res) => {
        setErrMsg(res.payload);
      })
      .catch((err) => {
        if (!err?.response) {
          setErrMsg("No Server Response");
        }
        errRef.current.focus();
      });
  };

  return (
    <div>
      <Container maxWidth="sm">
        <Grid
          container
          spacing={4}
          direction="column"
          justifyContent="center"
          style={{ minHeight: "70vh", borderRadius: "10px" }}
        >
          <Paper elelvation={2} sx={{ padding: 5, borderRadius: 2 }}>
            <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
              <CssBaseline />
              <Grid container direction="column" spacing={2}>
                <Grid
                  item
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img height="50px" src={logo} alt="SIMS" />
                </Grid>
                <Grid item sx={{ padding: 0 }}>
                  <TextField
                    type="email"
                    fullWidth
                    label="Email Address"
                    placeholder="Email Address"
                    variant="filled"
                    ref={userRef}
                    required
                    inputProps={{ style: { fontSize: 18 } }}
                    InputLabelProps={{ style: { fontSize: 18 } }}
                    onChange={(e) =>
                      setValues({ ...values, email: e.target.value })
                    }
                  />
                </Grid>

                <Grid item>
                  <TextField
                    type={values.showPass ? "text" : "password"}
                    fullWidth
                    label="Password"
                    placeholder="Password"
                    variant="filled"
                    ref={userRef}
                    required
                    inputProps={{ style: { fontSize: 18 } }}
                    InputLabelProps={{ style: { fontSize: 18 } }}
                    onChange={(e) =>
                      setValues({ ...values, password: e.target.value })
                    }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handlePassVisibilty}
                            aria-label="toggle password"
                            edge="end"
                          >
                            {values.showPass ? (
                              <VisibilityOffIcon />
                            ) : (
                              <VisibilityIcon />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                      style: { fontSize: 38 },
                    }}
                  />
                </Grid>

                <Grid
                  item
                  sx={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Button
                    size="small"
                    sx={{ width: "49%" }}
                    variant="outlined"
                    onClick={handleForgotPasswordClick}
                  >
                    Forgot Password
                  </Button>
                  <Button
                    size="small"
                    type="submit"
                    sx={{ width: "49%" }}
                    variant="contained"
                  >
                    Sign In
                  </Button>
                </Grid>
              </Grid>
            </form>
            <section>
              <Typography
                ref={errRef}
                style={{
                  color: "red",
                  textAlign: "center",
                }}
                aria-live="assertve"
              >
                {errMsg}
              </Typography>
            </section>
          </Paper>
        </Grid>
      </Container>
      <Container sx={{ maxWidth: "1100px !important" }}>
        <div
          style={{
            padding: "25px",
            borderRadius: "2px",
            backgroundColor: "white",
          }}
        >
          Dear quanti-user, welcome to SiMS!
          <br />
          To login for the first time please enter your email and press “Forgot
          Password”.
          <br />A password will be sent to your email address.
          <br />
          Use the password provided to login, until Single Sign On is enabled.
          <br />
          When you have any questions/remarks please let Jorrit &nbsp;
          <a
            style={{ color: "#007bff !important" }}
            href="mailto: jkouwenb@amgen.com"
          >
            (jstuut@amgen.com)
          </a>
          &nbsp;or Alberto &nbsp;
          <a
            style={{ color: "#007bff !important" }}
            href="mailto: mgobbens@amgen.com)"
          >
            (apistis@amgen.com)
          </a>
          &nbsp;know!
          <br />
          Thanks.
        </div>
      </Container>
      <br />
    </div>
  );
};

export default Login;
